/**
 * Smoothly scroll a container to a target offset using an ease-in-out curve.
 * This gives a slow → fast → slow feel, unlike the browser default smooth scroll.
 */
export function easeInOutScroll(container, targetTop, duration = 700, onComplete) {
  const startTop = container.scrollTop
  const distance = targetTop - startTop
  const startTime = performance.now()

  // Cubic ease-in-out: starts slow, accelerates, then decelerates.
  const easeInOutCubic = (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2

  const step = (now) => {
    const elapsed = now - startTime
    const progress = Math.min(elapsed / duration, 1)
    const eased = easeInOutCubic(progress)

    container.scrollTop = startTop + distance * eased

    if (progress < 1) {
      requestAnimationFrame(step)
    } else if (onComplete) {
      onComplete()
    }
  }

  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches

  if (prefersReducedMotion) {
    container.scrollTop = targetTop
    return
  }

  requestAnimationFrame(step)
}
